import { ActionLink, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface IPaginationErrorProps {
  onClick: () => void;
}

export const PaginationError: React.FC<IPaginationErrorProps> = ({ onClick }) => {
  return (
    <div className={styles['pagination-error']}>
      <UIText1 color="text-secondary-default">Произошла ошибка</UIText1>
      <span className={styles['pagination-error-button']}>
        <ActionLink type="button" onClick={onClick} fontWeight="bold">
          Попробовать снова
        </ActionLink>
      </span>
    </div>
  );
};
